<template>
	<div>
		<div
			class="modal"
			id="addToCampaignGroup"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add To Campaign Group</h5>
						<button type="button" class="close" @click="hideModal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body main_form_block" style="margin-top:5px;margin-left:270px;width:40%">
						<button
							id="tagsListing"
							data-toggle="modal"
							data-target="#addCampaignGroup"
							@click="showEditCampaign"
							class="tagsListing btn btn-primary add-new"
							style="width:100%"
						>New Campaign Group</button>
						<div
							v-show="showSpin"
							class="spinner-border"
							style="margin:auto;display:block;margin-top:60px"
						></div>
						<div v-show="!showSpin" class="ml-1">
							<Multiselect
								v-model="selectedCampaignGroup"
								:options="campaignGroupFilterList"
								:searchable="true"
								:multiple="false"
								:taggable="false"
								label="name"
								track-by="id"
								placeholder="Select Campaign Group"
								class="form-control multi-dropdown select_filter"
								selectLabel = ""
							/>
							<!-- <select
								class="form-control"
								id="campaignGroupSelection"
								style="margin-top:28px;margin-bottom:18px"
								v-model="selectedCampaignGroup"
							>
								<option value>--Select Campaign Group --</option>
								<option
									v-for="item in showMainOptions(campaignGroupFilterList)"
									:key="item.id"
									:value="item.id"
								>{{item.name}}</option>
							</select>
							<span class="no-data-style" v-if="submitted && !selectedCampaignGroup">Select campaign group to proceed</span> -->
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" @click="save()">Save</button>
							<button type="button" class="btn btn-secondary" @click="hideModal()">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<EditCampaignGroupModal
			v-if="campaignId"
			@updateCampaignGroupList="updateCampaignGroupList"
			@toggleEditCampaignGroupModal="toggleEditCampaignGroupModal"
			campaignId="NullWithPrefilledVendorBrand"
			:campaignVendor_id="selectedVendorFilter"
			:campaignBrand_id="selectedBrandProfile"
		></EditCampaignGroupModal>
	</div>
</template>

<script>
	import EditCampaignGroupModal from "@/components/campaign-group/EditCampaignGroupModal";
	import Multiselect from "vue-multiselect";

	export default {
		name: "AddToCampaignGroupModal",
		components: {
			EditCampaignGroupModal,
			Multiselect
		},
		mounted() {
			//this.openCampaignGroup();
		},
		data() {
			return {
				openCampGrpModal: false,
				showSpin: false,
				id: "NullWithPrefilledVendorBrand",
				campaignId: "",
				submitted:false
			};
		},
		watch: {},
		methods: {
			showMainOptions(list){
				
				let filteredList = list.filter(option => (option.id != 'all' && option.name != 'orphan' && option.name != 'ORPHAN'))

			},
			toggleEditCampaignGroupModal() {},
			fetchCampaignGroupList() {
				this.showSpin = true;
				const vm = this;
				let payload = {ams_profile_id:this.$store.state.campaign.campaignList[0].profile_id}
				this.$store
					.dispatch("campaign/getCampaignGroupFilterList",payload)
					.then(res => {
						vm.showSpin = false;
					});
			},
			updateCampaignGroupList(data) {
				
				this.showSpin = true;
				const vm = this;
				let payload = {}
				if(data && data.brand_id){
					payload = {ams_profile_id:data.brand_id}
				}
				this.$store
					.dispatch("campaign/getCampaignGroupFilterList",payload)
					.then(res => {
						if(data){
							this.selectedCampaignGroup = data;
						}
						vm.showSpin = false;
					});
			},
			hideModal() {
				this.submitted = false
				this.selectedCampaignGroup = "";
				this.$emit("hideAddToCampaignGroupModal", false);
			},
			save() {
				
				this.submitted = true
				this.selectedCampaignGroup = this.selectedCampaignGroup.id
				if(this.selectedCampaignGroup){
					this.submitted = false
					this.$emit("bulkCampaignGroupAssociation");
				}
			},
			// openCampaignGroup() {
			// 	this.openCampGrpModal = true;
			// 	$("#editCampaign").modal("show");
			// },
			showEditCampaign() {
				this.campaignId = this.id;
				const vm = this;
				this.$nextTick(() => {
					window.$("#editCampaign").modal({
						show: true
					});
					window.$("#editCampaign").on("hide.bs.modal", function(e) {
						e.stopImmediatePropagation();
						vm.campaignId = "";
					});
				});
			}
		},
		computed: {
			selectedCampaignGroup: {
				get() {
					return this.$store.state.latestCampaignGroup;
				},
				set(val) {
					this.$store.state.latestCampaignGroup = val;
				}
			},
			campaignGroupFilterList: {
				get() {
					
					//this.showMainOptions(this.$store.state.campaign.campaignGroupFilterList)
					return this.$store.state.campaign.campaignGroupFilterList;
				},
				set(val) {
					
					this.$store.state.campaign.campaignGroupFilterList = val;

				}
			},
			selectedBrandProfile() {
				if(this.$route.name=='campaignListPerGroup' || this.$route.name=='campaignList'){
					return this.$store.state.campaign.campaignList[0].profile_id
				}
				else{
					return this.$store.state.selelctedBrandProfile;
				}
			},
			selectedVendorFilter() {
				
				if(this.$route.name=='campaignListPerGroup'){
					return this.$store.state.campaign.campaignList[0].campaign_group_vendor
				}
				else if(this.$route.name=='campaignList'){
					return this.$store.state.campaign.campaignList[0].campaign_vendor_id
				}
				else{
					return this.$store.state.selectedVendorFilter;
				}
			}
		}
	};
</script>
<style lang="scss">
</style>
